// extracted by mini-css-extract-plugin
export default {"table":"styles_table__yfYa5","actions":"styles_actions__00d95"};